/**
 * Parse YouTube video ID from common URL shapes (watch, shorts, youtu.be).
 */
export function extractYouTubeVideoId(url: string): string | null {
  const raw = url.trim()
  if (!raw) return null
  try {
    const u = new URL(raw.startsWith("http") ? raw : `https://${raw}`)
    if (u.hostname === "youtu.be") {
      const id = u.pathname.replace(/^\//, "").split("/")[0]
      return id && /^[\w-]{6,}$/.test(id) ? id : null
    }
    if (u.hostname.includes("youtube.com") || u.hostname.includes("youtube-nocookie.com")) {
      if (u.pathname.startsWith("/shorts/")) {
        const id = u.pathname.split("/")[2]
        return id && /^[\w-]{6,}$/.test(id) ? id : null
      }
      const v = u.searchParams.get("v")
      if (v && /^[\w-]{6,}$/.test(v)) return v
    }
  } catch {
    return null
  }
  return null
}

/** Embed URL (privacy-enhanced host). */
export function getYouTubeEmbedSrc(videoId: string): string {
  const id = videoId.trim()
  if (!id) return ""
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}`
}


export async function fetchYouTubeOEmbed(titleUrl: string): Promise<{ title?: string; thumbnail_url?: string }> {
  const encoded = encodeURIComponent(titleUrl.trim())
  const res = await fetch(`https://www.youtube.com/oembed?url=${encoded}&format=json`)
  if (!res.ok) return {}
  try {
    const json = (await res.json()) as { title?: string; thumbnail_url?: string }
    return { title: json.title, thumbnail_url: json.thumbnail_url }
  } catch {
    return {}
  }
}
